import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle,DialogContentText, TextField, Button } from '@mui/material';
import { FileUpload } from '@mui/icons-material';

const BarchartModuleEditDialog = ({ open, onClose, onSubmit, type_action, data_selected }) => {
    
    const [datalabel, setDateLabel] = useState("");
    const [dataentry, setDataEntry] = useState(0);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    /*Function to extract Month */
    const extractMonth = (date) => {
        const monthIndex = date.getMonth(); // Returns 0 for January, 1 for February, and so on...
        const month = monthIndex + 1; // Adding 1 to get the actual month number
        return month;
    };

    /*Function to change data format */
    const formatDateForSQL=(date)=> {
      const formattedDate = date.toISOString().split('T')[0] + ' ' + date.toTimeString().split(' ')[0]
      return formattedDate
    }

    const handleinsertentry = () => {
        
        data_selected['value'] = dataentry
        data_selected['TS'] = formatDateForSQL(new Date())
        data_selected['month'] =extractMonth(new Date())

        onSubmit(data_selected)
        onClose()
    }

    const handleChange = (e) => {
        const value = e.target.value;
    
        // Check if value is numeric and within the 0-100 range
        if (!isNaN(value) && Number.isInteger(parseFloat(value)) && value >= 0 && value <= 100) {
          setDataEntry(value);
          setError(false);
          setErrorMessage('');
        } else {
          setError(true);
          setErrorMessage('Value must be an integer between 0 and 100.');
        }
      };

    useEffect(() => {
        if (type_action === 1) {
            setDateLabel(data_selected['year'])
        } else if (type_action === 0) {
            setDateLabel(data_selected['year'])
            setDataEntry(data_selected['value'])
        }
    }, [open])

    const [file, setFile] = useState(null); // State to hold the uploaded file

    // Function to handle file upload
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
    };


    return(
        <Dialog 
            open={open} 
            onClose={onClose}
            PaperProps={{ style: { backgroundColor: '#231E39'}}}
        >
            {type_action === 0 ?(
                <>
                    <DialogTitle style={{color: 'white'}}>Updating existing data entry</DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{color: 'lightgray', marginLeft: '5rem', marginRight: '5rem'}}>
                            Please enter a number between 0 and 100 for the year shown below.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="date_entry"
                            label={datalabel}
                            value={dataentry}
                            type="number"
                            fullWidth
                            variant="standard"
                            onChange={handleChange}
                            error={error}
                            helperText={error ? errorMessage : ''}
                            sx={{
                                '& .MuiInput-input': { backgroundColor: 'PowderBlue', color: 'black' },
                                '& .MuiInputLabel-root': { color: 'white' },
                                '& .MuiFormHelperText-root': { color: 'red' }, // Customize the error message color if needed
                            }}
                        />

                        <Button 
                            onClick={() => handleinsertentry()}
                            variant='text'
                            sx={{
                                paddingRight: '1.5rem',
                                marginRight: '1.5rem',
                                border: '1px solid var(--main-color)', 
                                color: 'var(--main-color)'
                            }}
                            >
                            Update entry!
                        </Button>

                                       {/* File Upload Button */}
                                       <label htmlFor="file-upload">
                    <Button
                        variant="outlined"
                        component="span"
                        startIcon={<FileUpload />}
                        sx={{
                            paddingRight: '1.5rem',
                            marginRight: '1.5rem',
                            border: '1px solid var(--main-color)',
                            color: 'var(--main-color)',
                        }}
                    >
                        Upload File (beta test -- available soon!)
                    </Button>
                </label>
                <input
                    id="file-upload"
                    type="file"
                    accept=".pdf" // Specify accepted file types if necessary
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />


                    </DialogContent>    
                </>
            ): type_action === 1 ? (
                <>
                    <DialogTitle style={{color: 'white'}}>Reporting a new data entry</DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{color: 'lightgray', marginLeft: '5rem', marginRight: '5rem'}}>
                            Please enter a number between 0 and 100 for the year shown below.
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="date_entry"
                            label={datalabel}
                            value={dataentry}
                            type="number"
                            fullWidth
                            variant="standard"
                            onChange={handleChange}
                            error={error}
                            helperText={error ? errorMessage : ''}
                            sx={{
                                '& .MuiInput-input': { backgroundColor: 'PowderBlue', color: 'black' },
                                '& .MuiInputLabel-root': { color: 'white' },
                                '& .MuiFormHelperText-root': { color: 'red' }, // Customize the error message color if needed
                            }}
                        />

                         <Button 
                            onClick={() => handleinsertentry()}
                            variant='text'
                            sx={{
                                paddingRight: '1.5rem',
                                marginRight: '1.5rem',
                                border: '1px solid var(--main-color)', 
                                color: 'var(--main-color)'
                            }}>
                            Insert entry
                        </Button>


                                       {/* File Upload Button */}
                <label htmlFor="file-upload">
                    <Button
                        variant="outlined"
                        component="span"
                        startIcon={<FileUpload />}
                        sx={{
                            paddingRight: '1.5rem',
                            marginRight: '1.5rem',
                            border: '1px solid var(--main-color)',
                            color: 'var(--main-color)',
                        }}
                    >
                        Upload File (beta test -- capability in progress)
                    </Button>
                </label>
                <input
                    id="file-upload"
                    type="file"
                    accept=".pdf" // Specify accepted file types if necessary
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />

                    </DialogContent>    
                </>
            ):(
                <DialogTitle style={{color: 'white'}}>Remove data entry</DialogTitle>
            )}

            <DialogActions
                sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}
            >
                <Button 
                    onClick={onClose}
                    sx={{
                    paddingRight: '1.5rem',
                    marginRight: '1.5rem',
                    border: '1px solid var(--main-color)',
                        
                }}>Cancel</Button>
                        
            </DialogActions>

        </Dialog>
    )
}

export default BarchartModuleEditDialog